<div class="d-flex flex-column justify-content-center align-items-center h-100 mb-4 mt-4">
  <img class="mb-3" src="assets/error/error-logo.svg" style="width: 350px; height: 350px" />
  <h6 class="fw-semibold mb-3">Server Error</h6>
  <span class="text-muted mb-4"> Something went wrong on our end.<br> Please try again in a moment. </span>
  <button class="btn btn-outline-dark btn-md" (click)="refresh()">Refresh</button>
</div>
